import React, { FocusEvent, MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import InsertHtmlContent from 'components/Common/InsertHtmlContent/InsertHtmlContent';
import Button from 'components/UI/Buttons/Button/Button';
import useHorizontalScroll from 'hooks/Utils/useHorizontalScroll/useHorizontalScroll';
import { getUri } from 'services/generic';
import { Acp } from 'types/Acp';

import styles from './AutocompleteCategories.module.scss';

type Props = {
  categories: Acp['pages'];
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
};

export default function AutocompleteCategories({
  categories,
  onClick,
}: Props): JSX.Element {
  const {
    ref,
    props: { onMouseUp, onMouseDown, onMouseMove },
  } = useHorizontalScroll<HTMLDivElement>();

  return (
    <div className={styles.container}>
      <div
        role={'tablist'}
        aria-label={'scroll'}
        className={styles.result}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
        tabIndex={-1}
      >
        {categories.map(({ id, url, label, highlight }) => (
          <Button
            key={id}
            component={Link}
            to={getUri(url)}
            className={styles.categoryLink}
            onClick={onClick}
            role={'tab'}
            onFocus={(e: FocusEvent) =>
              e.target.scrollIntoView({ block: 'nearest' })
            }
          >
            {highlight ? <InsertHtmlContent htmlContent={highlight} /> : label}
          </Button>
        ))}
      </div>
    </div>
  );
}
